var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurvey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FFEBC4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11V19H19V8H11C10.2044 8 9.44129 8.31607 8.87868 8.87868C8.31607 9.44129 8 10.2044 8 11V11ZM17 17H10V11C10 10.7348 10.1054 10.4804 10.2929 10.2929C10.4804 10.1054 10.7348 10 11 10H17V17Z",
    fill: "#7F4C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 29C7.99999 29.7956 8.31606 30.5587 8.87867 31.1213C9.44128 31.6839 10.2043 32 11 32H19V21H7.99999V29ZM9.99999 23H17V30H11C10.7348 30 10.4804 29.8946 10.2929 29.7071C10.1053 29.5195 9.99999 29.2652 9.99999 29V23Z",
    fill: "#7F4C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 21V32H28.9998C29.7955 32 30.5586 31.6839 31.1212 31.1213C31.6838 30.5587 31.9998 29.7956 31.9998 29V21H20.9999ZM29.9998 29C29.9998 29.2652 29.8945 29.5195 29.707 29.7071C29.5194 29.8946 29.2651 30 28.9998 30H22.9999V23H29.9998V29Z",
    fill: "#7F4C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 19H26.9999V15H30.9999V13H26.9999V8.99995H24.9999V13H20.9999V15H24.9999V19Z",
    fill: "#7F4C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.9575581ce4294b2c0cab78aa74cd81dd.svg";
export { ForwardRef as ReactComponent };